import FormField from './form-field';
import TextInput from './text-input';

const TextInputField = (props) => {
	return <FormField {...props} formControl={TextInput} />;
};

export default TextInputField;
